import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Meta } from '@df/core/meta/meta';
import { DfEventData } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { TimeoutService } from '@df/ng/timeout.service';
import './gtm-event-content-view';

@Injectable({
    providedIn: 'root'
})
export class GtmEventContentViewTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * meta service
     */
    private meta = inject(Meta);

    /**
     * location service
     */
    private location = inject(Location);

    /**
     * Timeout service
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Dispatch count
     */
    private count = 1;

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        let lastPath = undefined;
        const debounced = this.timeoutService.debounce((trigger: DfEventData, model: Product<IProductDataV3>) => {
            const path = this.meta.getMetaProperty('url') || this.location.path();
            if (lastPath !== path) {
                lastPath = path;
                this.dispatch(path);
            }
        }, 300);

        this.meta.subscribe(debounced);
    }

    /**
     * Dispatch event
     */
    private async dispatch(path: string) {
        return this.gtmService.dispatch({
            event: 'content_view',
            content: {
                count: this.count++,
                path,
                type: this.meta.state?.pageType,
                metaData: this.meta.state?.metaData,
                // model: this.meta.model,
                error: this.meta.status === 404 ? '404' : this.meta.status === 500 ? '500' : undefined
            }
        });
    }
}
